const isProduction = true; // Set to true for production environment, false for development

export const API_BASE_URL = isProduction
  ? "https://api.intelserve.io/api"
  : "http://localhost:5000/api";
export const BACKEND_ROOT_URL = isProduction
  ? "https://api.intelserve.io"
  : "http://localhost:5000";
